import { MenuOpenReducer } from './MenuOpenReducer';
import { combineReducers } from 'redux';
import {UserReducer} from "./UserReducer";
import {CompanyReducer} from "./CompanyReducer";

export const Reducers = combineReducers({
  MenuOpenReducer,
  UserReducer,
  CompanyReducer
});